<!-- ============================================================================= -->
<!-- Ella Custom JS - Customize The Style For Layout -->
<!-- ============================================================================= -->

<!-- ============================================================================= -->
<!-- IMPORTANT DISCLAIMER -->
<!-- Please use only JS to style the layout. -->
<!-- ============================================================================= -->

document.querySelectorAll("li.menu-lv-item.menu-lv-1.has-megamenu.dropdown.block_layout--full").forEach(item=>{
    const targetBanner = item.querySelector(".wrapper-colunm-menu.not_banner");
    targetBanner?.remove();
    const element = item.querySelector(".site-nav-banner.d-flex.ft-0.ls-0.flex-jc-end.background-bottom");
    if (element) {
      
      element.classList.remove("flex-jc-end");
      element.classList.add("flex-jc-center");
      
    }
});

document.querySelectorAll('video').forEach(video => {
  video.controls = false;
});

// Keep the legacy footer and menu customization on the original layout only.
// The current footer has its own styling and the theme already renders its menu.
if (document.querySelector(".copyright__content")) {
  document.querySelector(".copyright__content").style.cssText = "font-size:10px;position:absolute;bottom:0;";

  $(document).ready(function(){
    $(".mobileMenu-toggle").on("click",function(){
      const navMenuLinks = window.lpNavMenuLinks;
      let HTML = "<ul style='list-style-type:none'>";
      $.each(navMenuLinks,function(k,i){
          HTML += `<li><a href="${i.url}">${i.title}</a></li>`;
      });
      HTML += "</ul>";
      $("#navigation-mobile .site-nav-mobile.nav-currency-language.p-relative").after().html(`<div class="lp-mobile-nav">${HTML}</div>`);
    });
  });
}
